module.exports = __webpack_public_path__ + "img/products.4c248562.svg";